import { Component, OnDestroy, OnInit } from "@angular/core";
import * as _ from "lodash";
import * as moment from "moment";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";

import { Router } from "../../../../../node_modules/@angular/router";
import { TAAConstants } from "../../../../views/constants/taa-constants";
import { HeaderService } from "../../../../views/services/header.service";
import { InternalSendEmailService } from "../../common/services/internalsendemail.service";
import { AccommodationService } from "../services/accommodation.service";
import { ConsultantDecisionService } from "../services/consultant-decision.service";
import { PersonRequestService } from "../services/person-request-service";

@Component({
  templateUrl: "./consultant-reviewsubmit.component.html",
  styleUrls: ["./consultant-reviewsubmit.component.css"]
})
export class ConsultantReviewSubmitComponent implements OnInit, OnDestroy {
  public personId: string = "";
  public requestId: string = "";
  public reviewDetailId: string = "";
  public orgMdmId: string = "";
  public sourceSystem: string = "";
  public testNm: string = "";
  public testDateNm: string = "";
  public taaPin: string = "";
  public firstNm: string = "";
  public middleNm: string = "";
  public actId: string = "";
  public lastNm: string = "";
  public studentName: string = "";
  public accomms: any = [];
  public reqAccomms: any;
  public reqStatusCd: any;
  public emailList: any;
  public loading: boolean = false;
  public hasApprovedAccomms: boolean = false;
  public approvedStatusCdId: string = "";
  public pendingStatusCdId: string = "";
  public notApprovedStatusCdId: string = "";
  public partiallyApprovedStatusCdId: string = "";
  public paragraphList: any = [];
  public specAuthList: any = [];
  public displayData: any;
  public confirmationMsg: string = "";
  public otherAccommId: string = "";
  public testDateId: string = "";
  public testId: string = "";
  public toSend: any;
  public submittedByDs: string = "";
  public submittedByNm: string = "";
  public submitterRoleCd: string = "";
  public consultantId: string = "";
  public requestTypeCd: string = "";
  private subscriptions: Array<Subscription> = [];
  public specAuth: any;
  public auth: any;
  public submittedStatusCdId: string = "";
  public reviewToDate: any;
  public adminId: string = "";
  public dob: string = "";
  public hsCode: any;
  public selectedTestType: string = "";
  public submitData: any = [];
  public personTestList: any = [];
  public requestedAccomms: any = [];
  public otherText: string = "";
  public testName: string = "";
  public requestStatusCodeName: string = "";
  public prevReqStatusCode: string = "";
  public perviousStatus: string = "";
  public partiallyApprovedStatusCd: string = "";
  public approvedStatusCd: string = "";
  public hideExpDate: boolean;

  constructor(
    public consultantDecisionService: ConsultantDecisionService,
    public router: Router,
    public internalSendEmailService: InternalSendEmailService,
    public personRequestService: PersonRequestService,
    public accommodationService: AccommodationService,
    public headerService: HeaderService,
    public taaConstants: TAAConstants
  ) {}

  ngOnInit() {
    if (sessionStorage.getItem("reviewDetailId")) {
      this.reviewDetailId = sessionStorage.getItem("reviewDetailId");
    } else {
      this.reviewDetailId = "";
    }

    if (sessionStorage.getItem("requestId")) {
      this.requestId = sessionStorage.getItem("requestId");
    } else {
      this.requestId = "";
    }

    Observable.forkJoin(
      this.personRequestService.getReqAccomsById(this.requestId)
    ).subscribe(([requestedAccomms]) => {
      this.requestedAccomms = requestedAccomms;
      this.displayData = this.consultantDecisionService.getReviewData();
      this.requestedAccomms.forEach(element => {
        if (this.displayData.reqAccomms.length > 0) {
          this.displayData.reqAccomms.forEach(item => {
            if (
              element.ACCOMMODATION_ID === item.ACCOMM_VALUE.ACCOMMODATION_ID ||
              (item.OTHER_DS !== "" && item.OTHER_DS === element.OTHER_DS)
            ) {
              item.REQUESTED_ACCOMMODATION_ID =
                element.REQUESTED_ACCOMMODATION_ID;
            }
          });
        }
      });

      this.accomms = this.displayData.reqAccomms.concat(
        this.displayData.approvedAccomms
      );
      this.submitData = this.accomms;
      const currentdate: any = new Date();
      if (this.accomms.length > 0) {
        this.accomms.forEach(i => {
          if (i.EXP_DATE && Date.parse(i.EXP_DATE) < Date.parse(currentdate)) {
            i.EXP_DATE = moment(
              i.EXP_DATE,
              "DD-MMM-YY hh.mm.ss.SSSSSSSSS a"
            ).format("MM/DD/YYYY");
            this.hideExpDate = true;
          }
        });
      }
      this.paragraphList = this.displayData.paragraph;
    });

    Observable.forkJoin(
      this.personRequestService.getSpecAuth(this.requestId)
    ).subscribe(([auth]) => {
      this.specAuth = auth;
      this.specAuth = _.uniqBy(this.specAuth, "CODE_NM");
    });

    Observable.forkJoin(
      this.personRequestService.getPersonRequestForDisplay(this.requestId)
    ).subscribe(([request]) => {
      this.personId = request[0].PERSON_ID;
      this.orgMdmId = request[0].ORG_MDM_ID;
      this.testId = request[0].TEST_ID;
      this.testDateId = request[0].TEST_DATE_ID;
      this.sourceSystem = request[0].SOURCE_SYSTEM;
      this.submittedByNm = request[0].SUBMITTED_BY_NM;
      this.submittedByDs = request[0].SUBMITTED_BY_DS;
      this.submitterRoleCd = request[0].SUBMITTER_ROLE_CD;
      this.requestTypeCd = request[0].REQUEST_TYPE_CD;
      this.prevReqStatusCode = request[0].REQUEST_STATUS_CODE_ID;
      this.hsCode = request[0].HS_CODE ? request[0].HS_CODE : "";
      this.consultantId = request[0].CONSULTANT_ID;
      this.personRequestService
        .getRequestStatusCodeById(this.prevReqStatusCode)
        .subscribe(perviousStatus => {
          this.perviousStatus = perviousStatus[0].STATUS_CD;
        });

      if (this.personId.length === 0) {
        console.log("PersonId empty");
      } else {
        Observable.forkJoin([
          this.personRequestService.getPersonById(this.personId),
          this.personRequestService.getPersonNameById(this.personId),
          this.personRequestService.getTestNameByTestId(this.testId),
          this.personRequestService.getTestDateName(this.testDateId),
          this.personRequestService.getPersonTestById(this.personId),
          this.accommodationService.getAccommodationByNm("O"),
          this.consultantDecisionService.getAllStatusCode()
        ])
          .finally(() => {})
          .subscribe(
            ([
              person,
              personName,
              test,
              testAdmin,
              personTest,
              otherAccomm,
              reqStatusCode
            ]) => {
              this.taaPin = person[0].ACCOMMS_PIN ? person[0].ACCOMMS_PIN : "";
              this.dob = person[0].BIRTH_DT
                ? moment(person[0].BIRTH_DT)
                    .utc()
                    .format("MM/DD/YYYY")
                : "";

              this.firstNm = personName[0].FIRST_NM
                ? personName[0].FIRST_NM
                : "";
              this.middleNm = personName[0].MIDDLE_NM
                ? personName[0].MIDDLE_NM
                : "";
              this.lastNm = personName[0].LAST_NM ? personName[0].LAST_NM : "";

              this.personTestList = personTest;

              // Build name for email to organization
              this.studentName = this.firstNm + " " + this.lastNm;

              this.testNm = test[0].TEST_NM;
              this.testDateNm = testAdmin[0].TEST_DATE_NM;
              this.selectedTestType = testAdmin[0].TEST_DATE_TYPE;
              this.reviewToDate = testAdmin[0].REVIEW_TO_DT;
              this.adminId = testAdmin[0].ADMIN_ID;
              this.otherAccommId = otherAccomm[0].ACCOMMODATION_ID;
              this.reqStatusCd = reqStatusCode;

              this.reqStatusCd.forEach(element => {
                if (element.STATUS_CD === "NotApproved") {
                  this.notApprovedStatusCdId = element.REQUEST_STATUS_CODE_ID;
                } else if (element.STATUS_CD === "PartiallyApproved") {
                  this.partiallyApprovedStatusCdId =
                    element.REQUEST_STATUS_CODE_ID;
                  this.partiallyApprovedStatusCd = element.STATUS_CD;
                } else if (element.STATUS_CD === "Pending") {
                  this.pendingStatusCdId = element.REQUEST_STATUS_CODE_ID;
                } else if (element.STATUS_CD === "Approved") {
                  this.approvedStatusCdId = element.REQUEST_STATUS_CODE_ID;
                  this.approvedStatusCd = element.STATUS_CD;
                }
              });
            }
          );
      }
    });
  }

  // Preview what the decision document will look like for that gets uploaded to repository
  previewDocument() {
    //generate pdf
    let today: any = new Date();
    today = this.getFormattedDate(today);

    let paragraphs = "";
    this.paragraphList.forEach(element => {
      paragraphs += element.PARAGRAPH_TX;
    });

    let specAuths = "";

    this.specAuth.forEach(element => {
      specAuths += element.CODE_DS + "<br/>";
    });

    let notApproved = "";
    this.accomms.forEach(element => {
      this.otherText = "";
      if (element.OTHER_DS !== "") {
        this.otherText = ": " + element.OTHER_DS;
      }
      if (element.STATUS_CD === "Not Approved") {
        notApproved +=
          element.ACCOMM_VALUE.ACCOMMODATION_DS + this.otherText + "<br/>";
      }
    });

    const previewData = {
      STUDENT_NAME: this.studentName,
      REQUEST_ID: this.requestId,
      PERSON_ID: this.personId,
      REVIEW_DETAIL_ID: this.reviewDetailId,
      DECISION_DATE: today,
      APPROVED_ACC: this.formatAccoms(),
      NOT_APPROVED_ACC: notApproved,
      PARAGRAPH_LIST: paragraphs,
      SPEC_AUTH_LIST: specAuths,
      MODE: "STREAM",
      fileName: "DecisionNotificationDocument.pdf"
    };

    Observable.forkJoin(
      this.consultantDecisionService.storeDecisionDocInfo(previewData)
    ).subscribe(([documentResp]) => {
      const documentRtn: any = documentResp;
      if (documentRtn) {
        this.consultantDecisionService.previewDecisionFile();
      }
    });
  }

  goToDecision() {
    this.router.navigate(["/consultantDecision"]);
  }
  getFormattedDate(date) {
    const year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return month + "/" + day + "/" + year;
  }

  formatAccoms() {
    let approved = "";
    this.accomms.forEach(element => {
      if (element.STATUS_CD === "Approved") {
        this.otherText = "";
        if (element.OTHER_DS !== "") {
          this.otherText = ": " + element.OTHER_DS;
        }
        if (element.EXP_DATE !== "") {
          approved +=
            element.ACCOMM_VALUE.ACCOMMODATION_DS +
            this.otherText +
            " - Expires on " +
            moment(element.EXP_DATE, "DD-MMM-YY hh.mm.ss.SSSSSSSSS a").format(
              "MM/DD/YYYY"
            ) +
            "<br/>";
        } else {
          approved +=
            element.ACCOMM_VALUE.ACCOMMODATION_DS + this.otherText + "<br/>";
        }
      }
    });
    return approved;
  }

  submitReview() {
    //generate pdf
    let today: any = new Date();
    today = this.getFormattedDate(today);

    let paragraphs = "";
    this.paragraphList.forEach(element => {
      paragraphs += element.PARAGRAPH_TX;
    });

    let specAuths = "";
    this.specAuth.forEach(element => {
      specAuths += element.CODE_DS + "<br/>";
    });

    let notApproved = "";
    this.accomms.forEach(element => {
      this.otherText = "";
      if (element.OTHER_DS !== "") {
        this.otherText = ": " + element.OTHER_DS;
      }
      if (element.STATUS_CD === "Not Approved") {
        notApproved +=
          element.ACCOMM_VALUE.ACCOMMODATION_DS + this.otherText + "<br/>";
      }
    });

    const documentData = {
      STUDENT_NAME: this.studentName,
      REQUEST_ID: this.requestId,
      PERSON_ID: this.personId,
      REVIEW_DETAIL_ID: this.reviewDetailId,
      DECISION_DATE: today,
      APPROVED_ACC: this.formatAccoms(),
      NOT_APPROVED_ACC: notApproved,
      PARAGRAPH_LIST: paragraphs,
      SPEC_AUTH_LIST: specAuths,
      MODE: "UPLOAD"
    };

    Observable.forkJoin(
      this.consultantDecisionService.generateDecisionDocument(documentData)
    ).subscribe(([documentResp]) => {
      const documentRtn: any = documentResp;
      if (documentRtn.status === 200 || documentRtn.status === 204) {
        if (
          documentRtn.status === 200 &&
          documentRtn.body.status === "Similar document exists"
        ) {
          //   this.sameDocErrFlag = true;
        }
        if (
          documentRtn.status === 200 &&
          documentRtn.body === "Uploaded sucessfully"
        ) {
          // Determine whether to send out email after the request has been submitted
          // Send email after request has been submitted only if the flag is set and submitter is external user

          if (this.submitData.length > 0) {
            for (let v = 0; v < this.submitData.length; v++) {
              Observable.forkJoin(
                this.personRequestService.updateStatus(this.submitData[v])
              ).subscribe(
                ([updatedReqAccomm]) => {},
                error => {
                  console.log(error);
                }
              );
            }

            const uniqCount = _.uniq(_.map(this.submitData, "STATUS_CD"))
              .length;
            let data = {};
            let reviewData = {};
            if (uniqCount === 1) {
              //Always approved or notApproved
              data = {
                REQUEST_ID: this.requestId,
                PERSON_ID: this.personId,
                REQUEST_STATUS_CODE_ID: this.displayData.reqAccomms[0]
                  .REQUEST_STATUS_CODE_ID
              };
              reviewData = {
                REQUEST_STATUS_CODE_ID: this.displayData.reqAccomms[0]
                  .REQUEST_STATUS_CODE_ID,
                REQUEST_ID: this.requestId,
                STATUS_CD: this.displayData.reqAccomms[0].STATUS_CD,
                OLD_STATUS_CODE: this.perviousStatus,
                REVIEW_DETAIL_ID: this.displayData.reqAccomms[0]
                  .REVIEW_DETAIL_ID
              };

              this.submittedStatusCdId = this.displayData.reqAccomms[0].REQUEST_STATUS_CODE_ID;
            } else if (uniqCount === 0) {
              //section for Approved
              data = {
                REQUEST_ID: this.requestId,
                PERSON_ID: this.personId,
                REQUEST_STATUS_CODE_ID: this.approvedStatusCdId
              };
              reviewData = {
                REQUEST_STATUS_CODE_ID: this.approvedStatusCdId,
                REQUEST_ID: this.requestId,
                REVIEW_DETAIL_ID: this.reviewDetailId
              };
              this.submittedStatusCdId = this.approvedStatusCdId;
            } else {
              data = {
                REQUEST_ID: this.displayData.reqAccomms[0].REQUEST_ID,
                PERSON_ID: this.personId,
                REQUEST_STATUS_CODE_ID: this.partiallyApprovedStatusCdId
              };
              reviewData = {
                REQUEST_STATUS_CODE_ID: this.partiallyApprovedStatusCdId,
                REQUEST_ID: this.requestId,
                STATUS_CD: this.partiallyApprovedStatusCd,
                OLD_STATUS_CODE: this.perviousStatus,
                REVIEW_DETAIL_ID: this.reviewDetailId
              };
              this.submittedStatusCdId = this.partiallyApprovedStatusCdId;
            }
            this.personRequestService.updateRequestStatus(data).subscribe(
              success => {
                // update details of the review_detail on success
                this.personRequestService
                  .updateReviewDetailStatus(reviewData)
                  .subscribe(ret => {
                    this.headerService
                      .getSystemProperties()
                      .then(properties => {
                        this.toSend =
                          properties[
                            "SEND_EMAIL_AFTER_CONSULTANT_DECISION_SUBMIT"
                          ];
                        if (this.toSend === "1") {
                          if (
                            this.requestTypeCd !==
                            this.taaConstants.getPAPER_REQUEST()
                          ) {
                            let tacEmail = "";
                            const regexp = /SALESFORCE.|ACTB2B.(script)?/gi;
                            if (this.submittedByDs) {
                              tacEmail = this.submittedByDs.replace(
                                regexp,
                                "$1"
                              );
                            }
                            const emailData = {
                              STUDENT_NAME: this.studentName,
                              TAC_EMAIL: tacEmail,
                              TAC_NAME: this.submittedByNm,
                              REQUEST_ID: this.requestId
                            };
                            Observable.forkJoin(
                              this.internalSendEmailService.decisionMade(
                                emailData
                              )
                            ).subscribe(([emailResp]) => {
                              const emailRtn: any = emailResp;
                              console.log(
                                "emailRtn.status here " + emailRtn.status
                              );
                              if (
                                emailRtn.status === 200 ||
                                emailRtn.status === 204 ||
                                emailRtn.status === 201
                              ) {
                                this.onCloseHandled("confirmationModal");
                                if (
                                  sessionStorage.getItem("loggedInUserRole") ===
                                  "ACCMGR"
                                ) {
                                  this.router.navigate(["accmgr"]);
                                }

                                if (
                                  sessionStorage.getItem("loggedInUserRole") ===
                                  "ACCINTCONS"
                                ) {
                                  this.router.navigate(["intconslanding"]);
                                }
                              } else {
                                //Send email message to user of failure
                                const errorEmailData = {
                                  TAA_PIN: this.taaPin,
                                  CONSULTANT_ID: this.consultantId
                                };
                                Observable.forkJoin(
                                  this.internalSendEmailService.reviewSubmitError(
                                    errorEmailData
                                  )
                                ).subscribe(([emailRes]) => {
                                  const emailRt: any = emailRes;
                                  if (
                                    emailRt.status === 200 ||
                                    emailRt.status === 204 ||
                                    emailRt.status === 201
                                  ) {
                                    console.log("Approval Error email sent");
                                  } else {
                                    console.log("Send error mail failure");
                                  }
                                });
                              }
                            });
                          }
                        } else {
                          this.onCloseHandled("confirmationModal");
                          if (
                            sessionStorage.getItem("loggedInUserRole") ===
                            "ACCMGR"
                          ) {
                            this.router.navigate(["accmgr"]);
                          }

                          if (
                            sessionStorage.getItem("loggedInUserRole") ===
                            "ACCINTCONS"
                          ) {
                            this.router.navigate(["intconslanding"]);
                          }
                        }

                        // If approved or partiallyApproved then call endpoint for determining test type
                        if (
                          this.partiallyApprovedStatusCdId ===
                            this.submittedStatusCdId ||
                          this.approvedStatusCdId === this.submittedStatusCdId
                        ) {
                          const data2 = {
                            firstName: this.firstNm,
                            lastName: this.lastNm,
                            TAA_PIN: this.taaPin
                          };
                          // Return national or special from this call
                          Observable.forkJoin(
                            this.personRequestService.postTestType(data2)
                          ).subscribe(([result]) => {
                            if (result.status === 200) {
                              this.personTestList.forEach(element => {
                                const personTestObj = {};
                                personTestObj["PERSON_ID"] = this.personId;
                                personTestObj["TEST_DATE_ID"] =
                                  element.TEST_DATE_ID;
                                if (
                                  this.submitterRoleCd ===
                                  this.taaConstants.getROLE_IDMTAC()
                                ) {
                                  if (result.body["Test Type"] === "Special") {
                                    personTestObj["PERSON_TEST_TYPE"] =
                                      "Special";
                                    personTestObj["CERTIFIED_FL"] = "Y";
                                    personTestObj[
                                      "CERTIFIED_BY_DS"
                                    ] = this.submittedByNm;
                                    personTestObj[
                                      "CERTIFIED_ON_DT"
                                    ] = new Date();
                                  } else {
                                    personTestObj["PERSON_TEST_TYPE"] =
                                      "National";
                                    personTestObj["CERTIFIED_FL"] = "N";
                                  }
                                } else {
                                  personTestObj["PERSON_TEST_TYPE"] =
                                    result.body["Test Type"] === "Special"
                                      ? "Special"
                                      : "National";
                                }
                                this.personRequestService
                                  .putPersonTest(personTestObj)
                                  .subscribe(response => {
                                    if (response.status !== 200) {
                                      console.log(
                                        "failed to update PersonTest:"
                                      );
                                    }
                                  });
                              });
                            } else {
                              console.log(
                                "failed to update get test type from service"
                              );
                            }
                          });
                        }

                        const currentdate: any = new Date();

                        Observable.forkJoin(
                          this.personRequestService.getPersonAddressById(
                            this.personId
                          )
                        ).subscribe(
                          ([personAddress]) => {
                            const addressDetails: any = personAddress;
                            this.reqStatusCd.forEach(element => {
                              if (
                                this.submittedStatusCdId ===
                                element.REQUEST_STATUS_CODE_ID
                              ) {
                                this.requestStatusCodeName = element.STATUS_CD;
                              }
                            });

                            let count = 0;
                            const queueCalls = [];
                            this.personTestList.forEach((element, index) => {
                              let details: any = {};
                              const data1 = {
                                firstName: this.firstNm,
                                lastName: this.lastNm,
                                TAA_PIN: this.taaPin,
                                mode: element.TEST_MODE,
                                testOption: element.TEST_OPTION
                              };

                              Observable.forkJoin(
                                this.personRequestService.getTestDateNameById(
                                  element.TEST_DATE_ID
                                ),
                                this.personRequestService.getSourceFlag()
                              ).subscribe(([testType, sourceFlag]) => {
                                this.testName = testType.body[0].TEST_DATE_NM;
                                this.reviewToDate =
                                  testType.body[0].REVIEW_TO_DT;
                                this.adminId = testType.body[0].ADMIN_ID;
                                this.selectedTestType =
                                  testType.body[0].TEST_DATE_TYPE;
                                if (sourceFlag.body["sourceFlag"]) {
                                  this.sourceSystem = "MyACT";
                                }
                                if (this.sourceSystem === "MyACT") {
                                  details = {
                                    sourceSystem: this.sourceSystem,
                                    status: this.requestStatusCodeName,
                                    registration_id: element.REG_ID
                                      ? element.REG_ID
                                      : "",
                                    test_date: this.testName,
                                    admin_id: this.adminId,
                                    ext_admin_id: element.EXT_ADMIN_ID
                                      ? element.EXT_ADMIN_ID
                                      : "",
                                    request_status: "",
                                    taa_pin: this.taaPin,
                                    lName: this.lastNm,
                                    fName: this.firstNm,
                                    dob: this.dob,
                                    actId: this.actId ? this.actId : "",
                                    hsCode: this.hsCode,
                                    orgMdmId: this.orgMdmId,
                                    event: "accommodations.created"
                                  };
                                } else {
                                  details = {
                                    sourceSystem: this.sourceSystem
                                      ? this.sourceSystem
                                      : "",
                                    actId: this.actId ? this.actId : "",
                                    zip: addressDetails[0].ZIP_POSTAL_CD,
                                    extAdminId: element.EXT_ADMIN_ID
                                      ? element.EXT_ADMIN_ID
                                      : "",
                                    status: "",
                                    dob: this.dob,
                                    hsCode: this.hsCode ? this.hsCode : "",
                                    state: addressDetails[0].STATE_CD,
                                    lName: this.lastNm,
                                    taaPin: this.taaPin,
                                    fName: this.firstNm,
                                    city: addressDetails[0].CITY_NM,
                                    adminId: this.adminId,
                                    address: addressDetails[0].STREET_1_AD
                                      ? addressDetails[0].STREET_1_AD
                                      : "" + " " + addressDetails[0].STREET_2_AD
                                      ? addressDetails[0].STREET_2_AD
                                      : "",
                                    countryCd: addressDetails[0].COUNTRY_CD,
                                    mName: this.middleNm ? this.middleNm : "",
                                    regId: element.REG_ID
                                      ? +'"' + element.REG_ID + '"'
                                      : "",
                                    orderId: element.ORDER_ID
                                      ? element.ORDER_ID
                                      : ""
                                  };
                                }

                                if (this.reviewToDate) {
                                  if (
                                    (this.selectedTestType === "National" ||
                                      this.selectedTestType === "Special") &&
                                    Date.parse(this.reviewToDate) >=
                                      Date.parse(currentdate)
                                  ) {
                                    //if approved or partiallyApproved then call endpoint for determining Accommodations type(I.e, R,S,V,X calculation)
                                    if (
                                      this.partiallyApprovedStatusCdId ===
                                        this.submittedStatusCdId ||
                                      this.approvedStatusCdId ===
                                        this.submittedStatusCdId
                                    ) {
                                      Observable.forkJoin(
                                        this.personRequestService.postAccomsType(
                                          data1
                                        )
                                      ).subscribe(([accommsType]) => {
                                        count++;
                                        const accommStatus: any =
                                          accommsType.body;
                                        if (this.sourceSystem === "MyACT") {
                                          details.request_status =
                                            accommStatus.data.accomm_type;
                                        } else {
                                          details.status =
                                            accommStatus.data.accomm_type;
                                        }
                                        queueCalls.push(
                                          new Promise((resolve, reject) => {
                                            Observable.forkJoin(
                                              this.personRequestService.postRabbitMq(
                                                details
                                              )
                                            ).subscribe(
                                              ([temp]) => {
                                                resolve(temp.status);
                                                console.log(
                                                  "Added sucessfully to Rabbit " +
                                                    details
                                                );
                                              },
                                              err => {
                                                reject(err);
                                              }
                                            );
                                          })
                                        );
                                        if (
                                          count === this.personTestList.length
                                        ) {
                                          if (queueCalls.length === count) {
                                            Promise.all(queueCalls)
                                              .then(result => {
                                                console.log(result);
                                              })
                                              .catch(error => {});
                                          } else {
                                            console.log(
                                              "Send for Approve flow error Email"
                                            );
                                            const errorEmailData = {
                                              TAA_PIN: this.taaPin,
                                              CONSULTANT_ID: this.consultantId
                                            };

                                            Observable.forkJoin(
                                              this.internalSendEmailService.reviewSubmitError(
                                                errorEmailData
                                              )
                                            ).subscribe(([emailRespo]) => {
                                              const emailRetn: any = emailRespo;
                                              if (
                                                emailRetn.status === 200 ||
                                                emailRetn.status === 204 ||
                                                emailRetn.status === 201
                                              ) {
                                                console.log(
                                                  "Approval Error email sent"
                                                );
                                              } else {
                                                console.log(
                                                  "Send error mail failure"
                                                );
                                              }
                                            });
                                          }
                                        }
                                      });
                                    } else {
                                      count++;
                                      queueCalls.push(
                                        new Promise((resolve, reject) => {
                                          Observable.forkJoin(
                                            this.personRequestService.postRabbitMq(
                                              details
                                            )
                                          ).subscribe(
                                            ([temp]) => {
                                              resolve(temp.status);
                                              console.log(
                                                "Not approved response added sucessfully to RabbitMq"
                                              );
                                            },
                                            err => {
                                              reject(err);
                                            }
                                          );
                                        })
                                      );
                                      if (
                                        count === this.personTestList.length
                                      ) {
                                        Promise.all(queueCalls)
                                          .then(result => {
                                            console.log(result);
                                          })
                                          .catch(error => {});
                                      } else {
                                        console.log(
                                          "Send for Not Apporved flow error Email"
                                        );
                                        const errorEmailData = {
                                          TAA_PIN: this.taaPin,
                                          CONSULTANT_ID: this.consultantId
                                        };
                                        Observable.forkJoin(
                                          this.internalSendEmailService.reviewSubmitError(
                                            errorEmailData
                                          )
                                        ).subscribe(([emailResponse]) => {
                                          const emailReturn: any = emailResponse;
                                          if (
                                            emailReturn.status === 200 ||
                                            emailReturn.status === 204 ||
                                            emailReturn.status === 201
                                          ) {
                                            console.log(
                                              "Not Approved Error email sent"
                                            );
                                          } else {
                                            console.log(
                                              "Not approved error mail failure"
                                            );
                                          }
                                        });
                                      }
                                    }
                                  }
                                }
                              });
                            });
                          },
                          err => {}
                        );
                      });
                  });
              },
              err => {}
            );
          }
        }
      }
    });
  }
  confirmationModal() {
    this.confirmationMsg = "Are you sure you want to submit the review?";

    document.getElementById("confirmationModal").style.display = "block";
  }

  onCloseHandled(id) {
    document.getElementById(id).style.display = "";
  }

  ngOnDestroy() {
    for (const o of this.subscriptions) {
      o.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/consultant-review-submit/consultant-reviewsubmit.component.ts